import Vue from 'vue'
import { clearInterval, setInterval } from 'timers';
import PortfolioHistoryRow from './PortfolioHistoryRow.vue';
import WaitIndicator from '@/components/Common/WaitIndicator.vue';

import vue from 'vue'

export default vue.extend({
    props: {
        items: Array,
        portfolio: Object
    },
    data() {
        return {
            delay: { show: 100, hide: 1000 },
            DropdownClasses: {
                ItemClass: '',
                BtnClass: 'dropdown-toggle PortfolioToolbar__Button',
                DisabledBtnClass: 'dropdown-toggle PortfolioToolbar__Button btn-gray'
            }
        };
    },
    components: {
        PortfolioHistoryRow,
        WaitIndicator
    }
});